import { useFeatureIsOn } from '@growthbook/growthbook-react';

// گارد سوییچ ویزیت آنلاین — فقط پزشکانِ داخل این فلگ به مسیر جدید (لوتولی) می‌روند
// (پیایلوت: امیرحسین بیگی — تصمیم owner 2026-10-05)؛ بقیه همان مسیر قدیمی n8n.
// patient و نلسون‌فرانت روی یک کلید SDK «patient-production» هستند
// (GROWTHBOOK_CLIENT_KEY=sdk-St1dBftdp07geqtD) پس همان rule تولیدی
// user_id $in [3313319] اینجا هم ارزیابی می‌شود.
// برخلاف نلسون‌فرانت، بوت‌استرپ جدا لازم نیست: setUserInfo (لاگین و hydration لایهٔ
// entryPoint) attribute user_id را synchronous ست می‌کند و refreshFeatures می‌زند،
// و سوییچ فقط بعد از پر شدن استور کاربر رندر می‌شود — یعنی هنگام اولین کلیک،
// rule با user_id درست ارزیابی می‌شود (درس MR !160/!161 نلسون).
export const OV_BOOKING_GUARD_FEATURE = 'dr_ov_booking_guard';

export const useOvBookingGuardEnabled = () => useFeatureIsOn(OV_BOOKING_GUARD_FEATURE);
